module.exports = "<div class=\"as-map-footer\">\n  <div class=\"as-container\">\n    <div class=\"as-box\"></div>\n  </div>\n</div>\n"